const alwaysTrue = () => true;

export default alwaysTrue;
